window.LGFG = window.LGFG || {}
window.LGFG.FarmQuoteForm = window.LGFG.FarmQuoteForm || (function () {

    var initForm = function () {
        $('.js-intermediate-post-type-group').hide();

        $('.js-intermediate-post-checkbox').bind('change', function () {
            if (this.checked) {
                $('.js-intermediate-post-type-group').show();
            }
            else {
                $('.js-intermediate-post-type-group').hide();
            }
        });
    };

    return {
        init: function () {
            initForm();
        },
    };
});